import React from "react";
import { Box, Paper } from "@material-ui/core";

import { CustomButton, CustomCopyToClipboard } from "../..";
import { useSelectedTheme } from "../../../Hooks";

// Icons
import { CloseXIcon } from "../../../assets/icons";

import { useNewLayoutShared } from "../../../Contexts/NewLayoutSharedContext";

// Styles
import useStyles from "./styles";

function SuccessDialog() {
  const classes = useStyles();
  const {
    theme: { palette },
  } = useSelectedTheme();

  const { message, entity, hideDialog } = useNewLayoutShared();

  return (
    <Box className={classes.modalContainer}>
      <Paper className={classes.modalPaper}>
        <CloseXIcon
          onClick={hideDialog}
          className={classes.closeXIcon}
          width="24"
          height="24"
          fill={palette.foreground.quinary}
        />
        <Box onClose={hideDialog} className={classes.container}>
          <Box className={classes.content}>
            <Box id="generic-dialog-descripti">{message}</Box>
          </Box>
          <Box className={classes.containerBody}>
            <span className={classes.text}>{entity?.name}</span>

            <CustomCopyToClipboard
              data={entity?.id} // copy
              childrenData={"#" + entity?.id} // render
              copyDoneShowTime={1000}
              fontSize="14px"
            />
          </Box>

          <Box className={classes.actions}>
            <CustomButton
              boxShadow="xs"
              size="md"
              onClick={hideDialog}
              variant="outlined"
              color="secondary"
            >
              Close
            </CustomButton>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
}

export default SuccessDialog;
